import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
import DRNButton from '../../standard/Button/DRNButton';
import DRNHtmlText from '../../standard/HtmlText/DRNHtmlText';
import DRNText from '../../standard/Text/DRNText';
import variants from './variants';
import { ElementWithProps } from '@traveloka/prop-types';
class DRNInfoBox extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            containerWidth: 0,
            iconWidth: 0,
        };
        this.getBorderStyle = () => {
            const { isFullWidth } = this.props;
            /**
             * The full width has left inset shadow of 3px on X axis
             * Using border is the closest style we can get
             */
            if (isFullWidth) {
                return {
                    borderLeftWidth: 3,
                };
            }
            return {
                borderWidth: R.border.width.thin,
                borderRadius: R.border.radius.default,
            };
        };
        this.renderTextComponent = () => {
            const { message, variant, style } = this.props;
            const infoBoxStyle = variants[variant];
            const color = infoBoxStyle.textStyle.color;
            const anchorTagStyle = {
                a: Object.assign({}, R.typography.weightRegular, { color, textDecorationLine: 'underline' }, style),
                p: { marginTop: 0 },
            };
            return (<DRNHtmlText htmlStyles={anchorTagStyle} htmlText={message} style={Object.assign({}, R.typography.uiSmall, { color }, style)}/>);
        };
        this.enforceButtonLeftAlign = Action => {
            return React.cloneElement(Action, {
                style: {
                    marginTop: R.spacing.xxs,
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                },
                innerStyle: {
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                },
            });
        };
    }
    render() {
        const { variant, Icon, title, Action } = this.props;
        const infoBoxStyle = variants[variant];
        const EnforcedButton = Action ? this.enforceButtonLeftAlign(Action) : null;
        return (<View style={[style.container, infoBoxStyle.containerStyle, this.getBorderStyle()]}>
        <View style={style.headerWrapper}>
          {Icon && (<View style={style.iconWrapper}>
              <Icon />
            </View>)}
          {!!title && (<DRNText numberOfLines={1} variant={DRNText.VARIANT.UI_TINY} ink={DRNText.INK_VARIANT.SECONDARY}>
              {title}
            </DRNText>)}
        </View>
        <View style={style.messageWrapper}>{this.renderTextComponent()}</View>
        {EnforcedButton}
      </View>);
    }
}
DRNInfoBox.propTypes = {
    message: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(Object.keys(variants)).isRequired,
    Icon: PropTypes.func,
    title: PropTypes.string,
    isFullWidth: PropTypes.bool,
    style: PropTypes.object,
    Action: ElementWithProps(DRNButton, { size: DRNButton.SIZE.SMALL }),
};
DRNInfoBox.defaultProps = {
    isFullWidth: true,
    Icon: null,
    style: {},
};
const style = StyleSheet.create({
    container: {
        padding: R.spacing.s,
    },
    headerWrapper: {
        flexDirection: 'row',
    },
    iconWrapper: {
        marginRight: R.spacing.xs,
    },
    messageWrapper: {
        marginTop: R.spacing.xxs,
    },
});
Object.keys(variants).forEach(variant => {
    DRNInfoBox[variant] = variant;
});
export default DRNInfoBox;
